module.exports = __webpack_public_path__ + "static/in-fed-we-trust-944d670d276dfbc3bcf393e8d6b68862.jpg";